export default function CTASection() {
  return (
    <section className="py-4 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row rounded-3xl overflow-hidden bg-background-100">
          <div className="lg:w-1/2 relative min-h-[350px] md:min-h-[420px] overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20open%20laptop%20on%20minimalist%20desk%20displaying%20colorful%20product%20spreadsheet%20grid%20with%20thumbnail%20images%2C%20surrounded%20by%20fashion%20items%20and%20coffee%20cup%2C%20warm%20afternoon%20sunlight%20from%20large%20window%2C%20organized%20creative%20workspace%2C%20cream%20and%20wood%20tones%2C%20editorial%20productivity%20photography%2C%20clean%20modern%20aesthetic&width=800&height=900&seq=cta-store-v2-2026&orientation=portrait"
              alt="KASpreadsheet main store with spreadsheet interface"
              title="KASpreadsheet Store"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/15 to-transparent"></div>
            <div className="absolute top-6 left-6">
              <span className="text-xs text-background-50/70 font-medium uppercase tracking-widest">Official Store</span>
            </div>
            <div className="absolute bottom-8 left-6">
              <p className="font-heading text-3xl md:text-4xl font-bold text-background-50 leading-tight">
                Jump To<br />Main Store
              </p>
            </div>
          </div>

          <div className="lg:w-1/2 flex flex-col items-center justify-center px-8 md:px-12 py-12 md:py-16 text-center bg-background-50">
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-5 leading-tight">
              Explore KASpreadsheet
            </h2>
            <p className="text-foreground-600 text-sm md:text-base max-w-md mb-8 leading-relaxed">
              Ready to start shopping? Visit our main store at KASpreadsheet.com for the complete catalog with thousands of products organized through our powerful spreadsheet system. Find exactly what you need, compare prices, and shop smarter.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-foreground-900 text-background-50 font-semibold text-sm rounded-full hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap"
            >
              buy it now
              <i className="ri-arrow-right-up-line text-lg w-4.5 h-4.5 flex items-center justify-center"></i>
            </a>
            <p className="mt-4 text-xs text-foreground-400">
              Free to browse &bull; Updated daily &bull; Structured data
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}